export default __webpack_public_path__ + "static/media/Snd_LowerRSwim.2c9c2dc5.mp3";